/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Track_Check_InsInputs */

const en_admin_dashboard_track_check_ins = /** @type {(inputs: Admin_Dashboard_Track_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track who is in your space in real-time`)
};

const de_admin_dashboard_track_check_ins = /** @type {(inputs: Admin_Dashboard_Track_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieh, wer im Space vor Ort ist – in Echtzeit`)
};

const es_admin_dashboard_track_check_ins = /** @type {(inputs: Admin_Dashboard_Track_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realiza un seguimiento de quién está en tu espacio en tiempo real`)
};

const fr_admin_dashboard_track_check_ins = /** @type {(inputs: Admin_Dashboard_Track_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivez qui se trouve dans votre espace en temps réel`)
};

const it_admin_dashboard_track_check_ins = /** @type {(inputs: Admin_Dashboard_Track_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tieni traccia di chi è nel tuo spazio in tempo reale`)
};

const pt_br2_admin_dashboard_track_check_ins = /** @type {(inputs: Admin_Dashboard_Track_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhe quem está no seu espaço em tempo real`)
};

const pl_admin_dashboard_track_check_ins = /** @type {(inputs: Admin_Dashboard_Track_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledź, kto jest w Twojej przestrzeni w czasie rzeczywistym`)
};

const hu_admin_dashboard_track_check_ins = /** @type {(inputs: Admin_Dashboard_Track_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kövesse nyomon, ki van a helyiségben valós időben`)
};

const ro_admin_dashboard_track_check_ins = /** @type {(inputs: Admin_Dashboard_Track_Check_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urmariti cine este in spatiul dumneavoastra in timp real`)
};

/**
* | output |
* | --- |
* | "Track who is in your space in real-time" |
*
* @param {Admin_Dashboard_Track_Check_InsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_track_check_ins = /** @type {((inputs?: Admin_Dashboard_Track_Check_InsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Track_Check_InsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_track_check_ins(inputs)
	if (locale === "de") return de_admin_dashboard_track_check_ins(inputs)
	if (locale === "es") return es_admin_dashboard_track_check_ins(inputs)
	if (locale === "fr") return fr_admin_dashboard_track_check_ins(inputs)
	if (locale === "it") return it_admin_dashboard_track_check_ins(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_track_check_ins(inputs)
	if (locale === "pl") return pl_admin_dashboard_track_check_ins(inputs)
	if (locale === "hu") return hu_admin_dashboard_track_check_ins(inputs)
	return ro_admin_dashboard_track_check_ins(inputs)
});
export { admin_dashboard_track_check_ins as "admin.dashboard.track_check_ins" }